import { render, staticRenderFns } from "./ReviewListPopup.vue?vue&type=template&id=553e9f9a&scoped=true&"
import script from "./ReviewListPopup.vue?vue&type=script&lang=js&"
export * from "./ReviewListPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListPopup.vue?vue&type=style&index=0&id=553e9f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e9f9a",
  null
  
)

export default component.exports